import { Outlet } from 'react-router-dom';
import { ClientsProvider } from 'modules/client';

const ClientWrapper = () => {
    return (
        <ClientsProvider>
            <Outlet />
        </ClientsProvider>
    );
};

export default ClientWrapper;
